export default {
  sms: 'sms',
  default: 'default',
  whatsapp: 'whatsapp',
  custom: 'custom'
}
